import { curry } from 'lodash'
import { SelectOption } from 'scenes/Dashboard/components/Inputs/Select/Common/Select.model'
import { DateTrustCode } from 'scenes/Dashboard/data/common/types'
import { getPerformanceIndicatorLabel } from 'scenes/Dashboard/data/performanceIndicators/helpers'
import { PerformanceIndicator, PerformanceIndicatorType } from 'scenes/Dashboard/data/performanceIndicators/types'

export type PerformanceIndicatorFormValue = Omit<PerformanceIndicator, 'type'> & { type: SelectOption }

export const parsePerformanceIndicatorToFormValue = (
  performanceIndicator: PerformanceIndicator
): PerformanceIndicatorFormValue => ({
  ...performanceIndicator,
  type: getOptionFromPerformanceIndicatorType(performanceIndicator.type),
})

export const getOptionFromPerformanceIndicatorType = (type: string | PerformanceIndicatorType): SelectOption => ({
  value: type,
  label: getPerformanceIndicatorLabel(type),
})

export const parseFormValueToPerformanceIndicator = curry(
  (
    organizationId: PerformanceIndicator['organizationId'],
    performanceIndicatorFormValue: PerformanceIndicatorFormValue
  ): PerformanceIndicator => ({
    ...performanceIndicatorFormValue,
    organizationId,
    measuredOnTrustCode: DateTrustCode.yearMonth,
    type: getPerformanceIndicatorTypeFromOption(performanceIndicatorFormValue.type),
  })
)

export const getPerformanceIndicatorTypeFromOption = (option: SelectOption): PerformanceIndicatorType =>
  option && (option.value as PerformanceIndicatorType)
